/**
 * reserve-nav.js
 * 
 */
( function( $ ) {

    document.addEventListener( 'DOMContentLoaded', function() {

      let searchBar, toggler;

      searchBar = document.querySelector('.site-search');
      toggler   = document.querySelector('.js-search');

      document.onkeydown = function(evt) {
          evt = evt || window.event;
          var isEscape = false;
          if ("key" in evt) {
              isEscape = (evt.key == "Escape" || evt.key == "Esc");
          } else {
              isEscape = (evt.keyCode == 27);
          }
          if (isEscape) {
            document.body.classList.remove( 'search-active' );
            searchBar.classList.remove( 'site-search--active' );
          }
      };

      if( null == toggler )
        return;

      toggler.addEventListener( 'click', function( event ) {

        event.preventDefault();

        if ( document.body.classList.contains( 'search-active' ) ) {

          document.body.classList.remove( 'search-active' );
          searchBar.classList.remove( 'site-search--active' );

        } else {

          document.body.classList.add( 'search-active' );
          searchBar.classList.add( 'site-search--active' );

          setTimeout( function() { 
            document.querySelector(".js-search-input").focus(); 
          }, 1 );

        }

      });

    });

} )( jQuery );